import React from 'react';
import { Link } from 'react-router-dom';
import AuthPasswordHandle from '../../../components/common/auth/AuthPasswordHandle';
import AuthRootComponent from '../../../components/common/auth/AuthRootComponent';
import AuthHeaderTextComponent from '../../../components/common/auth/AuthHeaderTextComponent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18n from '../../../utils/i18n';
import { useEffect } from 'react';
const ResetPassword = () => {
  const language = useSelector((state) => state.languageReducer.language);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  const { t } = useTranslation(['auth', 'common']);
  return (
    <>
      <AuthRootComponent>
        <div className="w-full md:w-96 bg-white dark:bg-slate-800 dark:text-slate-200 px-6 py-10 rounded-md m-6">
          <AuthHeaderTextComponent
            title={t('common:reset_password')}
            desc={t('create_new_password_transactions')}
          />
          <AuthPasswordHandle slug={'passwordReset'} />
          <Link to="/login">
            <div className="my-3 text-center">
              <button className="text-[#3D4CB2] dark:text-GreenColor text-center inline-block">
                Login
              </button>
            </div>
          </Link>
        </div>
      </AuthRootComponent>
    </>
  );
};

export default ResetPassword;
